<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'

import AppSidebar from './AppSidebar.vue'
import AppTopbar from './AppTopbar.vue'
import { useUiStore } from '@/stores/ui'

const { t } = useI18n()
const ui = useUiStore()
const { sidebarOpenMobile } = storeToRefs(ui)
</script>

<template>
  <div class="shell">
    <a class="skip-link" href="#main-content">{{ t('ui.shell.skipToContent') }}</a>

    <AppSidebar />

    <div
      v-if="sidebarOpenMobile"
      class="shell__scrim"
      aria-hidden="true"
      @click="ui.sidebarOpenMobile = false"
    />

    <div class="shell__column">
      <AppTopbar />
      <main id="main-content" class="shell__main" tabindex="-1">
        <slot />
      </main>
    </div>
  </div>
</template>

<style scoped>
.shell {
  display: flex;
  min-height: 100vh;
  background: var(--surface-base);
}

.shell__column {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.shell__main {
  flex: 1;
  min-width: 0;
  outline: none;
}

.shell__scrim {
  position: fixed;
  inset: 0;
  z-index: 40;
  background: var(--scrim);
}

@media (min-width: 1025px) {
  .shell__scrim {
    display: none;
  }
}
</style>
